module.exports = __webpack_public_path__ + "img/about1.26cef033.png";